module.exports = __webpack_public_path__ + "static/media/megaphone.e716ca1c.svg";